import { APIResponse } from "../models/NetworkResponse";
import {
  PodCatalogListQuery,
  PodCatalogProductDetail,
  PodCatalogPaginated,
  PodCatalogProduct,
  PodCatalogUpsertBody,
  PodCatalogVariantsUpsertBody,
  POD_CATALOG_BASE,
} from "../models/Products/PodCatalog";
import { getAPI, postAPI, putAPI } from "./Networking";

export default class PodCatalogAPI {
  private buildListQueryParams(params: PodCatalogListQuery): string {
    const queryParams = new URLSearchParams();
    if (params.page_no != null)
      queryParams.append("page_no", String(params.page_no));
    if (params.limit != null) queryParams.append("limit", String(params.limit));
    if (params.search != null && params.search.trim() !== "")
      queryParams.append("search", params.search.trim());
    if (params.active !== undefined && params.active !== null)
      queryParams.append("active", String(params.active));
    if (params.product_id != null)
      queryParams.append("product_id", String(params.product_id));
    if (params.sort_by) queryParams.append("sort_by", params.sort_by);
    if (params.sort_type) queryParams.append("sort_type", params.sort_type);
    if (params.category_ids != null && params.category_ids.length > 0)
      queryParams.append("category_ids", params.category_ids.join(","));
    if (params.min_price != null) queryParams.append("min_price", String(params.min_price));
    if (params.max_price != null) queryParams.append("max_price", String(params.max_price));
    return queryParams.toString();
  }

  listPodCatalog = async (
    params: PodCatalogListQuery
  ): Promise<PodCatalogPaginated<PodCatalogProduct>> => {
    const qs = this.buildListQueryParams(params);
    const response = await getAPI(`${POD_CATALOG_BASE}${qs ? `?${qs}` : ""}`);
    return response.result as PodCatalogPaginated<PodCatalogProduct>;
  };

  getPodCatalogProduct = async (
    productId: number
  ): Promise<PodCatalogProductDetail> => {
    const response = await getAPI(`${POD_CATALOG_BASE}/pod-product/${productId}`);
    return response.result as PodCatalogProductDetail;
  };

  addPodCatalogProduct = async (
    productId: number
  ): Promise<APIResponse> => {
    return postAPI(`${POD_CATALOG_BASE}/add-product`, { productId });
  };

  removePodCatalogProduct = async (
    productId: number
  ): Promise<APIResponse> => {
    return postAPI(`${POD_CATALOG_BASE}/remove-product`, { productId });
  };

  upsertPodCatalogProduct = async (
    productId: number,
    body: PodCatalogUpsertBody
  ): Promise<APIResponse> => {
    const payload = Object.fromEntries(
      Object.entries(body).filter(([, value]) => value !== undefined)
    ) as PodCatalogUpsertBody;
    return putAPI(`${POD_CATALOG_BASE}/pod-product/${productId}`, payload);
  };

  upsertPodCatalogVariants = async (
    productId: number,
    body: PodCatalogVariantsUpsertBody
  ): Promise<APIResponse> => {
    return putAPI(`${POD_CATALOG_BASE}/pod-product/${productId}/variants`, body);
  };

  upsertPodCatalogImages = async (
    productId: number,
    body: { images: string[] }
  ): Promise<APIResponse> => {
    return putAPI(`${POD_CATALOG_BASE}/pod-product/${productId}/images`, body);
  };

}
